var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Screen", style: { width: _vm.width } }, [
    _c(
      "nav",
      { staticClass: "Screen_Tools" },
      [
        _c("ScreenToolbar", {
          attrs: { isScreenFit: _vm.isScreenFit, zoomValue: _vm.zoomValue },
          on: {
            zoomFit: function($event) {
              _vm.onZoomFit()
            },
            zoomIn: function($event) {
              _vm.onZoomIn()
            },
            zoomOut: function($event) {
              _vm.onZoomOut()
            },
            toggleHighlight: function($event) {
              _vm.onToggleHighlight()
            }
          }
        }),
        _vm._v(" "),
        _c("ul", { staticClass: "Screen_RightTools" }, [
          _c("li", { staticClass: "Screen_RightToolsItem" }, [
            _c(
              "button",
              {
                staticClass: "Screen_NavBarIconButton",
                on: { click: _vm.onOpenScreenEditor }
              },
              [_c("FontAwesomeIcon", { attrs: { icon: "image", size: "1x" } })],
              1
            )
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "Screen_Main" }, [
      _c("div", { staticClass: "Screen_MainInner" }, [
        _vm.isImageNotFound
          ? _c("div", { staticClass: "Screen_ImageNotFound" }, [
              _c("div", { staticClass: "Screen_ImageNotFoundWarn" }, [
                _vm._v(_vm._s(_vm.imageFilePath)),
                _c("br"),
                _vm._v("Image Not Found")
              ])
            ])
          : _c("div", {
              ref: "svgWrapper",
              staticClass: "UISP-Screen",
              class: {
                "UISP-Screen--fit": _vm.isScreenFit,
                "UISP-Screen--highlight": _vm.isHighlight
              },
              domProps: { innerHTML: _vm._s(_vm.svgCanvasHtml) }
            })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }